
export interface GaugePartProps {
  shape: 'start' | 'middle' | 'selected' | 'end';
  letter?: string;
  color: string;
  fontColor?: string;
}

const GaugePart = (props: GaugePartProps) => {
  switch (props.shape) {
    case 'start':
      return (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
            <path d="M0,12.15a4,4,0,0,1,4-4H32v8H4A4,4,0,0,1,0,12.15Z" fill={props.color} transform="translate(0 0)" />
          </svg>
        </>
      );
    case 'middle':
      return (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
            <rect fill={props.color} width="32" height="8" transform="translate(0 8)" />
          </svg>
        </>
      );
    case 'selected':
      return (
        <>
          <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto"></link>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
            <rect fill={props.color} width="32" height="24" rx="4" />
            <text
              x="50%"
              y="50%"
              dominantBaseline="middle"
              textAnchor="middle"
              fill={props.fontColor}
              fontSize="13"
              fontWeight="700"
              fontFamily="Roboto"
            >
              {props.letter}
            </text>
          </svg>
        </>
      );
    case 'end':
      return (
        <>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
            <path d="M28,16.15H0v-8H28a4,4,0,1,1,0,8Z" fill={props.color} transform="translate(0 0)" />
          </svg>
        </>
      );
  }
};

export default GaugePart;
